import { Box } from "@chakra-ui/react";
import DashBoard from "../components/Dashboard";
import { useMe } from "../components/api";
import { useAtom } from "jotai";
import { page_title } from "../components/global_state";

const Home = () => {
  const set_page_title = useAtom(page_title)[1];
  set_page_title("");

  const { data: me, isFetched: meFetched } = useMe();

  if (!meFetched) {
    return <></>;
  }
  if (!me) {
    return <AnonymousHome />;
  } else {
    return <DashBoard />;
  }
};

const AnonymousHome = () => {
  return <Box></Box>;
};

export default Home;
